import { LockOutcome } from './enums';

export type LockState =
  | 'Idle'
  | 'Acquiring'
  | 'Held'
  | 'HeldByOther'
  | 'HeartbeatFailed'
  | 'Releasing';

export interface LockHolder {
  reviewerAccountId: number;
  reviewerName: string | null;
}

export interface AcquireLockResult {
  outcome: LockOutcome;
  holderReviewerAccountId: number | null;
  lastHeartbeatAt: string | null;
}

export type HeartbeatResult =
  | { ok: true }
  | { ok: false; code: 'reviewLock.notFound' | string };

export const HEARTBEAT_INTERVAL_MS = 60_000;
export const QUEUE_POLL_INTERVAL_MS = 5 * 60_000;
export const STALE_LOCK_THRESHOLD_MS = 5 * 60_000;
